
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uGame/ang_pow",
      function () {
        return require("private-next-pages/uGame/ang_pow.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uGame/ang_pow"])
      });
    }
  